import { NativeStackScreenProps } from '@react-navigation/native-stack';
import React from 'react';

import JoinTournamentModal from '../Components/Modals/JoinTournamentModal';
import { RootStackParamList } from '../navigator';

type Props = NativeStackScreenProps<RootStackParamList, 'JoinTournaments'>;

const JoinTournamentsScreen: React.FC<Props> = ({ navigation, route: { params } }) => {
	const [isOpen, setIsOpen] = React.useState(true);

	if (!params?.tournamentId) {
		navigation.goBack();
		return null;
	}

	return (
		isOpen && (
			<JoinTournamentModal
				onClose={() => {
					setIsOpen(false);
					navigation.goBack();
				}}
				tournamentId={params.tournamentId}
			/>
		)
	);
};

export default JoinTournamentsScreen;
